import { AddIcon } from '@chakra-ui/icons';
import { Box } from '@chakra-ui/layout';
import { Avatar, Button, Flex, Text } from '@chakra-ui/react';
import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router';
import AvatarSrc from '../../../assets/images/logo.png';
// import AvatarSrc from '../../../assets/images/avatar.jpg';
// import BackgroundSrc from '../../../assets/images/background.jpg';
import TokenList from '../../../components/TokenList/index';
import * as RoutePaths from '../../../utils/constants/routings';
import { marketplaceContractAddress } from '../../../utils/constants/variables';
import UserContext from '../../../utils/contexts/User';
import useTokenList from '../../../utils/hooks/useTokenList';
import { InfoWrapper } from '../../NFT/styled-ui';
import MarketplaceHeader from '../components/header/index';
import { Description, Title } from '../styled-ui';

const MarketplaceDetails = () => {
  let history = useHistory();
  const { address } = useParams();
  const data = React.useContext(UserContext);
  const [query, setQuery] = useState('');
  const [pageNumber, setPageNumber] = useState(1);
  const { tokens, hasMore, loading, error } = useTokenList({ query, pageNumber });

  const handleSortMenu = async (value) => {
    setQuery(value);
    setPageNumber(1);
  };

  return (
    <>
      <Box position="relative">
        <MarketplaceHeader />
        {/* <Box loading="lazy" bgSize="cover" h={280} bgImage={BackgroundSrc}></Box> */}
        <Box
          maxW="1536"
          p={10}
          margin="0 auto"
          position="absolute"
          left={0}
          right={0}
          bottom={{ sm: -340, md: -240, lg: -120 }}
          top={{ base: 300, lg: 220 }}
          flexDir="column"
        >
          <Box display="flex" flexFlow="row wrap" gridGap={6}>
            <Flex flex={{ base: 1, md: 'auto', lg: 1 }} order={{ sm: 1, md: 1, lg: 2 }}>
              <InfoWrapper>
                <Avatar backgroundColor="transparent" loading="lazy" size="xl" src={AvatarSrc} />
                <Box ml="3">
                  <Title>Moon Rabbit NFT Marketplace</Title>
                  <Text colorScheme="gray.500" color="teal.200" fontWeight="bold">
                    <Description>{marketplaceContractAddress}</Description>
                  </Text>

                  <Flex
                    flexWrap="wrap"
                    gridRowGap={1}
                    pt={3}
                    justifyContent={{ base: 'center', md: 'start', lg: 'start' }}
                  >
                    {window.ethereum && data.account.address && (
                      <Button
                        leftIcon={<AddIcon />}
                        variant="outline"
                        colorScheme="black"
                        color="teal.200"
                        size="sm"
                        onClick={() => history.push(`${RoutePaths.CREATE_NFT}`)}
                      >
                        Create NFT
                      </Button>
                    )}
                    {/* <Button
                      ml={{ base: 0, lg: 4 }}
                      mt={{ base: 2, lg: 0 }}
                      variant="solid"
                      colorScheme="teal"
                      // color="teal.200"
                      size="sm"
                      onClick={() => history.push(`${RoutePaths.CREATE_NFT}`)}
                    >
                      featured collection
                    </Button> */}
                  </Flex>
                </Box>
              </InfoWrapper>
            </Flex>
          </Box>
        </Box>
      </Box>

      <Box pt={{ base: 240, sm: 340, md: 240, lg: 120 }}>
        <TokenList
          tokens={tokens}
          handleSort={handleSortMenu}
          loading={loading}
          setPageNumber={setPageNumber}
          hasMore={hasMore}
          address={address}
          error={error}
          headerTitle="Explore"
          headerVisability
        />
      </Box>
    </>
  );
};

export default MarketplaceDetails;
